import m from "./index262.js";
import { resolveComponent as a, createElementBlock as t, openBlock as n, normalizeClass as c, createElementVNode as r, createCommentVNode as i, toDisplayString as l, createBlock as d } from "vue";
/* empty css         */
import f from "./index231.js";
const v = ["data-component"], I = { class: "bg-white cs-inputField__wrapper" }, b = ["value", "inputmode", "disabled"], h = { class: "cs-inputField__label" }, F = {
  key: 0,
  class: "flex items-center justify-center h-full w-52"
}, k = {
  key: 0,
  class: "mt-12 text-caption text-color-alert-negative-100",
  "data-test-id": "error"
};
function w(e, s, y, g, B, E) {
  const p = a("ms-disabled"), u = a("ms-warning-circle");
  return n(), t("div", {
    class: c(["cs-inputField", {
      "-filled": e.modelValue !== "",
      "-focus": e.hasFocus,
      "-error": e.hasError && !e.isInactive,
      "-inactive": e.isInactive
    }]),
    "data-component": e.$options.name
  }, [
    r("label", I, [
      r("input", {
        ref: "input",
        class: "cs-inputField__input",
        type: "text",
        value: e.modelValue,
        inputmode: e.inputmode,
        disabled: e.disabled || e.isInactive,
        onBlur: s[0] || (s[0] = (...o) => e.onBlur && e.onBlur(...o)),
        onFocus: s[1] || (s[1] = (...o) => e.onFocus && e.onFocus(...o)),
        onInput: s[2] || (s[2] = (...o) => e.onInput && e.onInput(...o))
      }, null, 40, b),
      r("span", h, l(e.label), 1),
      e.isInactive || e.hasError || e.disabled ? (n(), t("span", F, [
        e.isInactive ? (n(), d(p, {
          key: 0,
          class: "self-center w-24 h-24"
        })) : i("", !0),
        e.hasError && (!e.isInactive || !e.disabled) ? (n(), d(u, {
          key: 1,
          class: "self-center w-24 h-24"
        })) : i("", !0)
      ])) : i("", !0)
    ]),
    e.hasError && !e.isInactive ? (n(), t("div", k, l(e.errorMsg), 1)) : i("", !0)
  ], 10, v);
}
const _ = /* @__PURE__ */ f(m, [["render", w], ["__scopeId", "data-v-34018154"]]);
export {
  _ as default
};
